import { Form } from "@inertiajs/react";
import PageHeader from "@/components/PageHeader";
import Button from "@/components/buttons/Button";
import Input from "@/components/inputs/Input";
import Select, { SelectOption } from "@/components/inputs/Select";
import FilterableSelect from "@/components/inputs/FilterableSelect";
import TagInput from "@/components/inputs/TagInput";
import TextArea from "@/components/inputs/TextArea";
import Checkbox from "@/components/inputs/Checkbox";
import InertiaLink from "@/components/buttons/InertiaLink";
import FormActions from "@/components/buttons/FormActions";

interface NewProps {
  artist_options: SelectOption[];
  song_key_options: SelectOption[];
  genre_options: SelectOption[];
}

const New: React.FC<NewProps> = ({
  artist_options,
  song_key_options,
  genre_options,
}) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      <PageHeader
        backLink={{ href: "/tracks", text: "Back to all tracks" }}
        title="Create new track"
      />
      <Form
        action="/tracks"
        method="post"
        className="dark:bg-cream-950 flex w-full flex-col gap-6 rounded-2xl bg-white p-6 shadow md:p-10"
      >
        {({ processing, errors }) => (
          <>
            <Select
              label="Artist *"
              name="artist_id"
              placeholder="Select an artist"
              options={artist_options}
              errors={errors.artist}
            />

            <Input
              type="text"
              label="Title *"
              name="title"
              placeholder="Enter track title"
              errors={errors.title}
            />

            <FilterableSelect
              label="Primary Genre"
              name="primary_genre"
              placeholder="Select a genre"
              options={genre_options}
              errors={errors.primary_genre}
            />

            <FilterableSelect
              label="Secondary Genre"
              name="secondary_genre"
              placeholder="Select a genre"
              options={genre_options}
              errors={errors.secondary_genre}
            />

            <Input
              type="text"
              label="ISRC Code"
              name="isrc_code"
              placeholder="e.g. USXXX0000000"
              errors={errors.isrc_code}
            />

            <Input
              type="text"
              label="UPC Code"
              name="upc_code"
              placeholder="Enter UPC code"
              errors={errors.upc_code}
            />

            <Input
              type="date"
              label="Release Date"
              name="release_date"
              errors={errors.release_date}
            />

            <TagInput
              label="Themes"
              name="themes"
              placeholder="e.g. Love, Coming of Age, Nostalgia"
              errors={errors.themes}
            />

            <TagInput
              label="Moods"
              name="moods"
              placeholder="e.g. Upbeat, Late Night Drive, Energetic"
              errors={errors.moods}
            />

            <Select
              label="Song Key"
              name="song_key"
              placeholder="Select a key"
              options={song_key_options}
              errors={errors.song_key}
            />

            <Input
              type="text"
              label="Tempo (BPM)"
              name="tempo_bpm"
              placeholder="e.g. 120"
              errors={errors.tempo_bpm}
            />

            <Input
              type="text"
              label="Time Signature"
              name="time_signature"
              placeholder="e.g. 4/4, 3/4"
              errors={errors.time_signature}
            />

            <Input
              type="text"
              label="Length"
              name="length"
              placeholder="e.g. 3:45"
              errors={errors.length}
            />

            <TextArea
              label="Description"
              name="description"
              placeholder="A short description of the track"
              errors={errors.description}
            />

            <Checkbox
              label="Content rating"
              checkboxLabel="Explicit"
              name="explicit"
              errors={errors.explicit}
            />

            <FormActions>
              <InertiaLink href="/tracks" type="secondary" text="Cancel" />
              <Button
                text={processing ? "Creating..." : "Create Track"}
                type="primary"
                htmlButtonType="submit"
                disabled={processing}
              />
            </FormActions>
          </>
        )}
      </Form>
    </div>
  );
};

export default New;
